var map = {
  "./calendar.svg": "51601",
  "./calendar_error.svg": "80300",
  "./card.svg": "50925",
  "./card_error.svg": "84496",
  "./card_pending.svg": "57065",
  "./card_success.svg": "34809",
  "./contact.svg": "73613",
  "./desktop_settings.svg": "95835",
  "./document.svg": "97026",
  "./email.svg": "18641",
  "./error.svg": "38783",
  "./folder.svg": "20139",
  "./help.svg": "6776",
  "./info.svg": "23003",
  "./mobile_key.svg": "42421",
  "./passkey.svg": "9101",
  "./payment_terminal.svg": "60760",
  "./peak.svg": "69628",
  "./qr.svg": "40196",
  "./search.svg": "85199",
  "./settings.svg": "64138",
  "./success.svg": "83274",
  "./system_error.svg": "6043",
  "./tada.svg": "15047",
  "./target.svg": "46970",
  "./upload.svg": "16922",
  "./warning.svg": "23405"
};


function webpackAsyncContext(req) {
  return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
  return __webpack_require__.e(/* lazy-once context | pictograms */ "919").then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 6430;
module.exports = webpackAsyncContext;
